exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".save-button[data-v-81e2a508] {\n  padding-left: 1.25rem;\n  padding-right: 1.25rem;\n  text-align: left;\n}\n.save-icon[data-v-81e2a508] {\n  right: 20px;\n  top: 18px;\n}\n", ""]);

// exports
